import {Infinity} from "react-bootstrap-icons";
import React from "react";

export const NO_LIMIT = -1;


function TotalSeatsSpan({ totalSeats }: { totalSeats?: number | null }) {
    return totalSeats === NO_LIMIT ? <Infinity/> : <>{totalSeats}</>;
}

function RemainingSeatsSpan({ totalSeats, usedSeats }: { totalSeats: number | null; usedSeats: number | null }) {
    if (typeof totalSeats === 'number' && typeof usedSeats === 'number') {
        return totalSeats === NO_LIMIT ? <Infinity /> : <>{totalSeats - usedSeats}</>;
    }
    return <>0</>;
}

const SeatSpan = {
    Total: TotalSeatsSpan,
    Remaining: RemainingSeatsSpan
}

export default SeatSpan;
